import React, { useEffect } from "react";
import { menuItem } from "../helper/constant";
import { FaBell } from "react-icons/fa";
import { Link, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetTab, setTabData } from "../redux/slices/tabSlice";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { IoMenuSharp } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import UserAvatar from "./UserAvatar";
import VersionInfo from "./VersionInfo";

export default function Layout() {
  const { t } = useTranslation();
  const selectedTab = useSelector((state) => state.tabData.tab);
  const profileData = useSelector((state) => state.profileData.profileData);
  const storedUserInfo = JSON.parse(localStorage?.getItem("zubrus_user_data"))?.data?.userInfo;
  const userData = {
    ...storedUserInfo,
    ...profileData,
    profilePictureUrl:
      profileData?.profilePictureUrl || storedUserInfo?.profilePictureUrl,
  };
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const handleClick = (e, title) => {
    e.stopPropagation();
    dispatch(setTabData(title));
    setIsOpen(false);
  };
  console.log('userData :>> ', userData?.userRoles);
  return (
    <main>
      <header className="h-20 sticky top-0 bg-white z-30 border border-b px-10 md:px-4 flex items-center justify-between">
        <div className="flex items-center gap-10 h-full">
          <Link to={
            userData?.userRoles?.includes('zubrus_admin')
              ? '/classes'
              : userData?.userRoles?.includes('zubrus_content_creator')
                ? '/classes'
                : userData?.userRoles?.includes('zubrus_parent')
                  ? '/mychildren'
                  : '/classes'
          }>
            <img
              src="/assets/images/LOGO.png"
              alt="LOGO"
              className="flex cursor-pointer"
              onClick={() => {
                if (userData?.userRoles?.includes("zubrus_admin")) {
                  dispatch(setTabData("classes"));
                } else if (userData?.userRoles?.includes("zubrus_content_creator")) {
                  dispatch(setTabData("workshops"));
                } else if (userData?.userRoles?.includes("zubrus_parent")) {
                  dispatch(setTabData("mychildren"));
                } else {
                  dispatch(setTabData("classes"));
                }
              }}
            />
            
          </Link>
          {/* {!pathname.includes("mychildren") && ( */}
          <ul className="flex items-center gap-5  md:hidden text-xl h-full text-lightgray font-semibold">
            {userData?.userRoles?.includes('zubrus_teacher') &&
              <>
                <Link
                  to={`/classes`}
                  className={`${selectedTab === "classes" && "border-b border-black text-black "
                    }  h-full  flex items-center justify-center cursor-pointer`}
                  onClick={() => {
                    dispatch(setTabData('classes'));
                  }}
                >
                  {t(`menuItems.classes`)}
                </Link>
                <Link
                  to={`/classes`}
                  className={`${selectedTab === "zubroteka" && "border-b border-black text-black "
                    }  h-full  flex items-center justify-center cursor-pointer`}
                  onClick={() => {
                    dispatch(setTabData('zubroteka'));
                  }}
                >
                  {t(`menuItems.zubroteka`)}
                </Link>
              </>
            }
            {userData?.userRoles?.includes('zubrus_content_creator') &&
              <>
                <Link
                  to={`/classes`}
                  className={`${selectedTab === "workshops" && "border-b border-black text-black "
                    }  h-full  flex items-center justify-center cursor-pointer`}
                  onClick={() => {
                    dispatch(setTabData('workshops'));
                  }}
                >
                  {t(`menuItems.workshops`)}
                </Link>
                {/* <Link
                    to={`/Content-creator`}
                    className={`${selectedTab === "Content-creator" && "border-b border-black text-black "
                      }  h-full  flex items-center justify-center cursor-pointer`}
                    onClick={() => {
                      dispatch(setTabData('Content-creator'));
                    }}
                  >
                    {t(`menuItems.Contentcreator`)}
                  </Link> */}
              </>
            }
            {userData?.userRoles?.includes('zubrus_admin') &&
              <Link
                // to={`/admin/dashboard`}
                to={`/admin/userlist`}
                className={`${selectedTab === "admin" && "border-b border-black text-black "
                  }  h-full  flex items-center justify-center cursor-pointer`}
                onClick={() => {
                  dispatch(setTabData('admin'));
                }}
              >
                {t(`menuItems.admin`)}
              </Link>
            }

            {userData?.userRoles?.includes('zubrus_parent') &&
              <>
                <Link
                  // to={`/admin/dashboard`}
                  to={`/mychildren`}
                  className={`${selectedTab === "child" && "border-b border-black text-black "
                    }  h-full  flex items-center justify-center cursor-pointer`}
                  onClick={() => {
                    dispatch(setTabData('child'));
                  }}
                >
                  {t(`mychild`)}
                </Link>
              </>
            }
          </ul>
          {/* )} */}
        </div>

        <div className="flex items-center gap-5 text-lightgray h-full">
          <div className="md:hidden">
            <FaBell fontSize={24} />
          </div>
          <Link
            to="/profile"
            className="h-full"
            onClick={() => dispatch(resetTab(""))}
          >
            <div
              className={`${pathname.includes("profile") ||
                pathname.includes("user") ||
                pathname.includes("change-password")
                ? "text-black border-b border-black"
                : "text-lightgray"
                } text-xl font-semibold flex h-full items-center gap-3`}
            >
              <span className="md:hidden capitalize"> {userData?.firstName} {userData?.lastName?.slice(0, 1)}. </span>
              <UserAvatar
                src={userData?.profilePictureUrl}
                firstName={userData?.firstName}
                lastName={userData?.lastName}
                username={userData?.username}
                email={userData?.email}
                size="sm"
              />
            </div>
          </Link>
          {/* {!pathname.includes("mychildren") && ( */}
          <div onClick={toggleDrawer} className="hidden md:flex">
            <IoMenuSharp fontSize={24} />
            <Drawer
              open={isOpen}
              onClose={toggleDrawer}
              direction="left"
              className="bla bla bla"
            >
              <div>
                {!pathname.includes("mychildren") && (
                  <ul className="flex flex-col items-start p-5 gap-5 text-xl h-full text-lightgray font-semibold">
                    {userData?.userRoles?.includes('zubrus_teacher') &&
                      <>
                        <Link
                          to={`/classes`}
                          className={`${selectedTab === "classes" && "border-b border-black text-black "
                            }  h-full  flex items-center justify-center cursor-pointer`}
                          onClick={() => {
                            dispatch(setTabData('classes'));
                          }}
                        >
                          {t(`menuItems.classes`)}
                        </Link>
                        <Link
                          to={`/classes`}
                          className={`${selectedTab === "zubroteka" && "border-b border-black text-black "
                            }  h-full  flex items-center justify-center cursor-pointer`}
                          onClick={() => {
                            dispatch(setTabData('zubroteka'));
                          }}
                        >
                          {t(`menuItems.zubroteka`)}
                        </Link>
                      </>
                    }
                    {userData?.userRoles?.includes('zubrus_content_creator') &&
                      <>
                        <Link
                          to={`/classes`}
                          className={`${selectedTab === "workshops" && "border-b border-black text-black "
                            }  h-full  flex items-center justify-center cursor-pointer`}
                          onClick={() => {
                            dispatch(setTabData('workshops'));
                          }}
                        >
                          {t(`menuItems.workshops`)}
                        </Link>
                      </>
                    }
                    {userData?.userRoles?.includes('zubrus_admin') &&
                      <Link
                        // to={`/admin/dashboard`}
                        to={`/admin/userlist`}
                        className={`${selectedTab === "admin" && "border-b border-black text-black "
                          }  h-full  flex items-center justify-center cursor-pointer`}
                        onClick={() => {
                          dispatch(setTabData('admin'));
                        }}
                      >
                        {t(`menuItems.admin`)}
                      </Link>
                    }
                    {userData?.userRoles?.includes('zubrus_parent') &&
                      <>
                        <Link
                          // to={`/admin/dashboard`}
                          to={`/mychildren`}
                          className={`${selectedTab === "child" && "border-b border-black text-black "
                            }  h-full  flex items-center justify-center cursor-pointer`}
                          onClick={() => {
                            dispatch(setTabData('child'));
                          }}
                        >
                          {t(`mychild`)}
                        </Link>
                      </>
                    }

                  </ul>
                )}
              </div>
            </Drawer>
          </div>
          {/* )} */}
        </div>
      </header>
      <section className="min-h-screen">
        <Outlet />
      </section>
      <footer className="bg-white py-5 ms-5 flex items-center justify-between">
        <span className="regular-text text-lightgray">{t("copyright")}</span>
        <VersionInfo 
          className="mr-5 relative" 
          showDetails={userData?.userRoles?.includes('zubrus_admin')} 
        />
      </footer>
    </main>
  );
}
